import { DomainRegistry } from "../../../domain";
import { Rectangle, Point, Size } from "../../drawing";
import { IDocumentImageSource } from "../IDocumentImageSource";
import { ImageKinds } from "../ImageKinds";
import { AbstractImageDrawableItem } from "./AbstractImageDrawableItem";
import { TypeKeys } from "./TypeKeys";

export class MovableImageItem extends AbstractImageDrawableItem {
  constructor() {
    super(TypeKeys.MovableImageItem);
  }

  public isResizeRequired: boolean = false;
  public isFreeDrawn: boolean = false;
 
  protected createCloneInstance(): MovableImageItem {
    return new MovableImageItem();
  }

  protected applyMembers(clone: MovableImageItem): void {
    super.applyMembers(clone);
    clone.isResizeRequired = this.cloneValue(this.isResizeRequired);
    clone.isFreeDrawn = this.cloneValue(this.isFreeDrawn);
  }

  static async fromImageSource(position: Point, imageSource: IDocumentImageSource, imageKind: ImageKinds): Promise<MovableImageItem> {
    const repository = DomainRegistry.document.getDocumentRepository();
    const item = await repository.createNewObjects("NewImage");
    const result = item as MovableImageItem;
    result.privateId = null;
    result.id = null;
    result.isEditable = true;
    result.isAdditional = true;
    result.isVisible = true;
    result.geometry.rectangle = new Rectangle(position, new Size(10, 10));
    result.imageSource = imageSource;
    result.originalImageSource = imageSource;
    result.drawLayerImageSource = await repository.createEmptyImageSource();
    result.drawObjectData = null;
    result.imageKind = imageKind;
    result.claioImageId = null;           // Claio由来の画像の場合はこのあと変更される
    result.imageDepartmentId = null;      // Claio由来の画像の場合はこのあと変更される
    result.isResizeRequired = true;
    result.externalImageId = null;        // 外部連携画像由来の画像の場合はこのあと変更される
    return result;
  }
}
